var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(this.$route.path != '/login')?_c('SuperiorMenu'):_vm._e(),(_vm.isMounted)?_c('v-main',{class:_vm.has_bottom_drawer ? '' : 'pb-0'},[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }